export default __webpack_public_path__ + "static/media/oxetrilhas_garota.cf8d470c.png";